import { render, staticRenderFns } from "./tooltip-button.vue?vue&type=template&id=7a56b83e"
import script from "./tooltip-button.vue?vue&type=script&lang=js"
export * from "./tooltip-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports